const PAGE_CONTAINER_GRADIENT = "linear-gradient(to bottom, rgba(113,81,55,1) 0%,rgba(0,0,0,0) 100%)";

export const setBackgroundImageStyle = (isPage: boolean, backgroundImage: string) => {
  if (!isPage) {
    return {
      backgroundImage: `url(${backgroundImage})`,
    };
  }

  return { backgroundImage: `${PAGE_CONTAINER_GRADIENT}, url(${backgroundImage})` };
};
